import { Spinner } from "react-bootstrap"

const MySpinner  = () => {
    return <Spinner animation="border" size="sm" className="me-2" />
}

export default MySpinner;